import { Inject, Injectable, NgZone } from '@angular/core'
import { MapColorGeneratorService } from '../../../../../features/map/services/map-color-generator.service'
import { DepartmentMapFilterService } from './department-map-filter.service'
import { IFilterDefTypeEnum } from '../../../../../shared/open-layers/layer-filter.interface'
import { MapColorGeneratorActions } from '../../../../../features/map/common/map-color-generator/state/action-types'
import { Store } from '@ngrx/store'
import { selectMapColorGeneratorColorMapByKey } from '../../../../../features/map/common/map-color-generator/state/map-color-generator.selectors'
import { filter, take } from 'rxjs/operators'

@Injectable({
    providedIn: 'root',
})
export class GeneralMapLayerDefinitionsConcernedService {

    colorList = {}

    constructor(@Inject(Store) private store: Store,
                @Inject(NgZone) private ngZone: NgZone,
                @Inject(DepartmentMapFilterService) private departmentMapFilterService: DepartmentMapFilterService,
                @Inject(MapColorGeneratorService) private mapColorGeneratorService: MapColorGeneratorService,
    ) {
    }

    public getLayers(concernedDetails): Promise<any> {
        return new Promise<any>(resolve => {
            const layers = []
            if (concernedDetails) {
                const concernedWithOpsubId = concernedDetails.allConcerned.filter((concerned) => concerned.opsubId != null)

                if (concernedWithOpsubId?.length) {
                    this.initColorList(concernedWithOpsubId).then(() => {
                        concernedWithOpsubId.forEach(concerned => {
                            if (concerned.subject) {
                                const color = this.colorList[concerned.opsubId]
                                const layer = {
                                    id: 'parcel_concerned_' + concerned.opsubId,
                                    type: 'wms',
                                    title: concerned.name,
                                    selector: 'switch',
                                    visible: false,
                                    selectorStyle: 'custom-icon-color',
                                    styleAttribute: this.mapColorGeneratorService.getMapLayerIconStyle(color.fill, color.stroke)
                                }

                                layers.push(layer)
                            }
                        })
                        resolve(layers)
                    })
                } else {
                    resolve(layers)
                }
            } else {
                resolve(layers)
            }
        })
    }

    public getConcernedLayer(id, url, layerPrefix): any {
        const colorData = this.colorList[id]
        const c = this.mapColorGeneratorService.getHexColor(colorData.mapColor)
        return {
            id: 'parcel_concerned_' + id,
            layer: {
                type: 'wms',
                url: url,
                wms: {
                    layers: layerPrefix + 'parcel_concerned',
                    format: 'image/png8',
                    transparent: true,
                    unloadInvisibleTiles: true,
                    noWrap: true,
                    zIndex: 360
                },
                filter: this.departmentMapFilterService.updateMapFilterDepartmentIdEqual({
                    type: IFilterDefTypeEnum.PropertyIsEqualTo,
                    propertyName: 'opsub_id',
                    literal: id
                }),
                sldBody: {
                    name: layerPrefix + 'parcel_concerned',
                    rules: [
                        {
                            name: 'parcel_concerned_' + id,
                            polygonSymbolizer: {
                                fill: {
                                    svgParameter: {
                                        'fill': c,
                                        'fill-opacity': colorData.mapOpacity
                                    }
                                },
                                stroke: {
                                    svgParameter: {
                                        'stroke': c,
                                        'stroke-width': 1
                                    }
                                }
                            }
                        }
                    ]
                }
            }
        }
    }

    // ---------

    private initColorList(concernedWithOpsubId): Promise<void> {
        return new Promise(resolve => {
            this.colorList = {}
            this.ngZone.run(() => {
                this.store.dispatch(MapColorGeneratorActions.getNextColors({ num: concernedWithOpsubId.length, ident: 'concerned' }))

                this.store.select(selectMapColorGeneratorColorMapByKey('concerned')).pipe(
                    filter((colors: any[]) => colors && colors.length >= concernedWithOpsubId.length),
                    take(1)
                ).subscribe(colors => {
                    for (let i = 0; i < concernedWithOpsubId.length; i++) {
                        this.colorList[concernedWithOpsubId[i].opsubId] = colors[i]
                    }
                    resolve()
                })
            })
        })
    }
}
